var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsearchSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.916,
    height: 26.916,
    viewBox: "0 0 30.916 30.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "M0-682.665H30.916v30.916H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g207",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g209",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g211",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g217",
    transform: "translate(2.545 0.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path219",
    d: "M0-229.131v-9.057A1.812,1.812,0,0,1,1.811-240H18.466a1.812,1.812,0,0,1,1.811,1.811v1.773",
    transform: "translate(0 239.999)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g221",
    transform: "translate(0.453 11.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path223",
    d: "M0-180.608v-6.756a1.811,1.811,0,0,1,1.811-1.811h8.836a1.571,1.571,0,0,1,1.523,1.189l.311,1.245a1.57,1.57,0,0,0,1.523,1.189h4.933",
    transform: "translate(0 189.176)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g225",
    transform: "translate(0.453 16.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path227",
    d: "M-504.087,0V11.791A1.811,1.811,0,0,1-505.9,13.6h-20.288A1.811,1.811,0,0,1-528,11.791V5.164",
    transform: "translate(527.999)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g229",
    transform: "translate(5.745 3.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path231",
    d: "M0,0H13.115",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g233",
    transform: "translate(5.745 5.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path235",
    d: "M0,0H10.4",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g237",
    transform: "translate(5.745 8.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path239",
    d: "M0,0H9.492",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g241",
    transform: "translate(20.645 16.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path243",
    d: "M-24.924,0l-1.182,2.048",
    transform: "translate(26.107)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g245",
    transform: "translate(18.612 15.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path247",
    d: "M-24.961,0l-1.184,2.05",
    transform: "translate(26.145)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g249",
    transform: "translate(13.557 17.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path251",
    d: "M-21.467-199.342h0a2.036,2.036,0,0,0,2.781-.745l3.6-6.243a.862.862,0,0,0-.316-1.178l-2.033-1.174a.862.862,0,0,0-1.178.316l-3.6,6.243A2.036,2.036,0,0,0-21.467-199.342Z",
    transform: "translate(22.485 208.798)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g253",
    transform: "translate(17.522 3.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path255",
    d: "M-13.295-77.687a6.479,6.479,0,0,1,5.84-3.685A6.478,6.478,0,0,1-.985-74.9a6.478,6.478,0,0,1-6.47,6.47,6.478,6.478,0,0,1-6.47-6.47,6.516,6.516,0,0,1,.043-.747",
    transform: "translate(13.925 81.372)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g257",
    transform: "translate(19.992 6.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path259",
    d: "M-84.337,0a4,4,0,0,0-4,4,4.005,4.005,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0-84.337,0Z",
    transform: "translate(88.337)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsearchSmall);
export default __webpack_public_path__ + "static/media/documentsearch_small.7b095f1baf0902c33c3a220583151681.svg";
export { ForwardRef as ReactComponent };